// Imports
import { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';


// Define the accepted props
interface Props {
	defaultPath: string;
}


// Function component
const HashRedirect: React.FC<Props> = ({ defaultPath }) => {
	// Use React Router functionality
	const navigate = useNavigate();
	const { hash } = useLocation();
	
	
	// Remove hash and navigate
	useEffect(() => {
		if (hash) {
			navigate(hash.replace(/^#/, ''), { replace: true });
		}
	}, [hash, navigate]);
	
	
	// Navigate to the provided default path if no hash
	if (!hash) {
		return <Navigate to={defaultPath} replace />;
	}
	
	
	// Display nothing
	return null;
};

export default HashRedirect;
